import React, { useEffect, useState } from "react";
import { GetAllApplicants, GetJobTitles } from "Services/OtherApis";
import { useLocation } from "react-router-dom";
import Table from "./table";

function AllApplicants() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const jobId = searchParams.get("job"); // Extracts the job value from query string

  const [data, setData] = useState([]);
  const [dataTitles, setDataTitles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dropdown, setDropDown] = useState(jobId ? jobId : "");
  useEffect(() => {
    if (dropdown === "All") {
      getAllApplicantsData("");
    } else {
      getAllApplicantsData(`?jobId=${dropdown}`);
    }
  }, [dropdown]);

  async function getAllApplicantsData(value) {
    setLoading(true);
    try {
      const res = await GetAllApplicants(value);

      setData(res?.data || []); // Ensure data is always an array
    } catch (e) {
      console.error("Error fetching jobs:", e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getJobsTitles();
  }, []);
  async function getJobsTitles() {
    setLoading(true);
    try {
      const res = await GetJobTitles("67989cad4b85cc8e672bbbe2");
      setDataTitles(res?.data || []); // Ensure data is always an array
    } catch (e) {
      console.error("Error fetching jobs:", e);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="w-full">
      <Table
        loading={loading}
        data={data}
        setDropDown={(e) => setDropDown(e)}
        dropdown={dropdown}
        dataTitles={dataTitles}
        isPreApplicants={false}
        isDropDown={true}
      />
    </div>
  );
}

export default AllApplicants;
